module.exports = __webpack_public_path__ + "img/m5.aa4b726a.png";